export class Help {
  private _codigo: number;
  private _modulo: string;
  private _pergunta: string;
  private _respostaSimplificada: string;
  private _respostaCompleta: string;
  private _caminho: string;
  private _data: string;
  private _visible: boolean;

  get codigo(): number {
    return this._codigo;
  }

  set codigo(value: number) {
    this._codigo = value;
  }

  get modulo(): string {
    return this._modulo;
  }

  set modulo(value: string) {
    this._modulo = value;
  }

  get pergunta(): string {
    return this._pergunta;
  }

  set pergunta(value: string) {
    this._pergunta = value;
  }


  get respostaSimplificada(): string {
    return this._respostaSimplificada;
  }

  set respostaSimplificada(value: string) {
    this._respostaSimplificada = value;
  }

  get respostaCompleta(): string {
    return this._respostaCompleta;
  }

  set respostaCompleta(value: string) {
    this._respostaCompleta = value;
  }

  get caminho(): string {
    return this._caminho;
  }

  set caminho(value: string) {
    this._caminho = value;
  }

  get data(): string {
    return this._data;
  }

  set data(value: string) {
    this._data = value;
  }


  get visible(): boolean {
    return this._visible;
  }

  set visible(value: boolean) {
    this._visible = value;
  }
}



// WEBPACK FOOTER //
// ./src/app/help/help.ts